import "./app.css"
import type { AlpineWithComponents } from "@nxtlvlsoftware/alpine-typescript/types/Global";
import "./config/sentry";
import "./utils/debug";
import "./ext";
import "./components";
import "./directives";
import "./handlers";
import "./office/actions";

import htmx from "htmx.org";
import Alpine from "alpinejs";
import { init as initAlpine } from "./utils/alpine";
import { initOnDOMContentLoaded } from "./office/state";

window.Alpine = Alpine as AlpineWithComponents;
window.htmx = htmx;
//window.htmx.config.globalViewTransitions = true;
window.htmx.config.globalViewTransitions = false;
window.htmx.config.historyCacheSize = 0;

// Register directives and components to alpine
initAlpine();

// Initialize the Office JS API
initOnDOMContentLoaded().catch(console.error);
